import React, { useMemo } from 'react';
import SelectUnbindDevices from '../SelectUnbindDevices';
import useSelectDevices from '@root/hooks/newSubscription/useSelectDevice';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import LayoutNavbar from '@root/components/LayoutNavbar';
import { useTranslation } from 'react-i18next';

const SelectDevice = () => {
  const {
    isChangePlan,
    maxDevNum,
    paying,
    loading,
    selected,
    expandDeviceList,
    onSelected,
    onClickPay,
    getPackageDetail,
  } = useSelectDevices();
  const { t } = useTranslation();

  if (loading < 1) {
    return (
      <LayoutNavbar
        navbarProps={{
          title: t('select_devices'),
        }}
      >
        <PageLoading />
      </LayoutNavbar>
    );
  }

  if (loading === 2) {
    return (
      <LayoutNavbar
        navbarProps={{
          title: t('select_devices'),
        }}
      >
        <PageLoadError onTryAgain={getPackageDetail} />
      </LayoutNavbar>
    );
  }

  return (
    <SelectUnbindDevices
      isChangePlan={isChangePlan}
      selected={selected}
      maxDevNum={maxDevNum}
      expandDeviceList={expandDeviceList}
      paying={paying}
      onChange={onSelected}
      onClickPay={onClickPay}
      btnText={t('pay_with_PayPal')}
    />
  );
};

export default SelectDevice;
